module.exports = __webpack_public_path__ + "sq4-2a1be64e.png";